import { mapActions } from "vuex";

export default {
  name: "TabBar",
  props: ["tab", "is_premium", "isBrokerUser", "isBrokerGuest"],

  methods: {
    ...mapActions("portfolioreport", {
      setTab: "setTab",
    }),

    tabId(tabName) {
      return `report-tab-${tabName}`;
    },

    panelId(tabName) {
      return `report-panel-${tabName}`;
    },

    visibleTabs() {
      const tabs = [];
      if (this.isBrokerUser == false || this.isBrokerGuest) {
        tabs.push("TradingAnalysis");
      }
      tabs.push(
        "Portfolio",
        "rating",
        "sector",
        "growth",
        "performance",
        "recommendations",
        "exisitvsrestruct"
      );
      return tabs;
    },

    isTabActive(tabName) {
      if (tabName === "TradingAnalysis") {
        return (
          this.tab === "TradingAnalysis" ||
          (this.is_premium == 1 &&
            this.tab === "pdf" &&
            (this.isBrokerUser == false || this.isBrokerGuest == true))
        );
      }
      if (tabName === "Portfolio") {
        return (
          this.tab === "Portfolio" ||
          (this.is_premium == 0 && this.tab === "pdf")
        );
      }
      return this.tab === tabName;
    },

    onTabClick(tab) {
      this.setTab(tab);
    },

    focusTab(tabName) {
      this.$nextTick(() => {
        const el = document.getElementById(this.tabId(tabName));
        if (el) {
          el.focus();
        }
      });
    },

    onTabKeydown(event, tabName) {
      const tabs = this.visibleTabs();
      const currentIndex = tabs.indexOf(tabName);
      if (currentIndex < 0) {
        return;
      }

      const { key } = event;

      if (key === "ArrowRight") {
        event.preventDefault();
        const nextTab = tabs[(currentIndex + 1) % tabs.length];
        this.onTabClick(nextTab);
        this.focusTab(nextTab);
      } else if (key === "ArrowLeft") {
        event.preventDefault();
        const prevTab = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
        this.onTabClick(prevTab);
        this.focusTab(prevTab);
      } else if (key === "Home") {
        event.preventDefault();
        this.onTabClick(tabs[0]);
        this.focusTab(tabs[0]);
      } else if (key === "End") {
        event.preventDefault();
        const lastTab = tabs[tabs.length - 1];
        this.onTabClick(lastTab);
        this.focusTab(lastTab);
      } else if (key === "Enter" || key === " ") {
        event.preventDefault();
        this.onTabClick(tabName);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/TabBar.js